<num-modal-window [displaySaveButtons]="false">
  <div class="about-modal-header">
    {{ 'APPLAYOUT.HEADER.ABOUT' | translate }}
  </div>

  <div class="about-modal-content">
    <!--UI-->
    <div class="info-section">
      <div class="section-header">{{ 'APPLAYOUT.HEADER.ABOUT_MODAL.UI' | translate }}</div>

      <num-info-tile label="APPLAYOUT.HEADER.ABOUT_MODAL.VERSION" [value]="aboutInfo?.ui?.version">
      </num-info-tile>

      <num-info-tile
        label="APPLAYOUT.HEADER.ABOUT_MODAL.COPYRIGHT"
        [value]="aboutInfo?.ui?.copyright"
      >
      </num-info-tile>

      <num-info-tile label="APPLAYOUT.HEADER.ABOUT_MODAL.EMAIL">
        <a [href]="'mailto:' + aboutInfo?.ui?.email" target="_blank">{{ aboutInfo?.ui?.email }}</a>
      </num-info-tile>
    </div>

    <!--Backend-->
    <div class="info-section">
      <div class="section-header">{{ 'APPLAYOUT.HEADER.ABOUT_MODAL.BACKEND' | translate }}</div>

      <num-info-tile
        label="APPLAYOUT.HEADER.ABOUT_MODAL.VERSION"
        [value]="aboutInfo?.backend?.version"
      >
      </num-info-tile>

      <num-info-tile
        label="APPLAYOUT.HEADER.ABOUT_MODAL.BUILD_TIME"
        [value]="aboutInfo?.backend?.buildTime"
      >
      </num-info-tile>

      <num-info-tile
        label="APPLAYOUT.HEADER.ABOUT_MODAL.BRANCH"
        [value]="aboutInfo?.backend?.branch"
      >
      </num-info-tile>

      <num-info-tile
        label="APPLAYOUT.HEADER.ABOUT_MODAL.COMMIT"
        [value]="aboutInfo?.backend?.commit"
      >
      </num-info-tile>
    </div>

    <!--Ontology-->
    <div class="info-section">
      <div class="section-header">{{ 'APPLAYOUT.HEADER.ABOUT_MODAL.ONTOLOGY' | translate }}</div>

      <num-info-tile
        label="APPLAYOUT.HEADER.ABOUT_MODAL.VERSION"
        [value]="aboutInfo?.ontology?.version"
      >
      </num-info-tile>
    </div>
  </div>

  <!--Buttons-->
  <div class="action-buttons">
    <num-button
      [matTooltip]="'APPLAYOUT.HEADER.ABOUT_MODAL.DOWNLOAD' | translate"
      type="blue"
      (click)="downloadAboutInfo()"
    >
      {{ 'APPLAYOUT.HEADER.ABOUT_MODAL.DOWNLOAD' | translate }}
    </num-button>
    <num-button
      [matTooltip]="'APPLAYOUT.HEADER.CLOSE' | translate"
      type="blue"
      (click)="closeModal()"
    >
      {{ 'APPLAYOUT.HEADER.CLOSE' | translate }}
    </num-button>
  </div>
</num-modal-window>
